// Footer institutionnel — liens vers les 4 pages légales
// Mentions légales · CGU · RGPD · Paramètres cookies

export default function Footer({ onChangeView, currentView }) {
  const links = [
    { id:"mentions", label:"Mentions légales" },
    { id:"cgu", label:"CGU" },
    { id:"rgpd", label:"RGPD" },
    { id:"cookies", label:"Paramètres cookies" },
  ];
  return (
    <footer
      data-testid="site-footer"
      className="-mx-3 -mb-3 md:-mx-8 md:-mb-8 lg:-mx-10 lg:-mb-10 mt-12 bg-[#0B1628] text-white/70 border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-[11px] tracking-wide text-white/50 text-center md:text-left">
          © {new Date().getFullYear()} <span className="font-bold text-white/80">Cabinet KEYTO</span> ·
          PCG interactif · Plan Comptable Général 2026
        </p>
        <nav className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
          {links.map((l) => {
            const active = currentView === l.id;
            return (
              <button
                key={l.id}
                data-testid={`footer-${l.id}`}
                onClick={() => onChangeView(l.id)}
                className={`text-[11px] font-semibold tracking-wide transition-colors ${
                  active
                    ?"text-white underline underline-offset-4 decoration-[#5AA0FF]"
                    :"text-white/60 hover:text-white"
                }`}
              >
                {l.label}
              </button>
            );
          })}
        </nav>
      </div>
    </footer>
  );
}
